import React from "react";
import clsx from "clsx";
import styles from "./index.module.scss";

type Props = {
  color: string;
  text: string;
};

export default function StatusIndicator({ color, text }: Props) {
  return (
    <div className={styles.status}>
      <span className={styles.outer}>
        <span className={styles.inner} style={{ backgroundColor: color }} />
      </span>

      <span className={clsx(styles.text, "capitalize-first-letter")}>
        {text}
      </span>
    </div>
  );
}
